/***
 * 彩票公用方法与操作
 */
import { computedLm, createHistoryKey } from '../../utils/computed';
import Vue from '../../utils/bus';
import { currentTabKey, lhComputedLm, lhCurrentTabLength } from "../../utils/lhComputed";
import objectPath from 'object-path';
import { onDeepData } from "../../utils/lhConfig";

const each = (cb, el) => {
  (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
  if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
};

export default {
  watch: {
    chip() {
      each(item => {
        if (item.selected) {
          item.value = this.chip;
        }
      }, this.$refs.c_model_input);
    },
    innerTabs: {
      deep: true,
      handler() {
        if (!this.innerTabs || !this.innerTabs.length) return;
        if (this.innerTab.class3 != '选二连直' && this.innerTab.class3 != '选二连组' && this.innerTab.class3 != '选三前组' && this.innerTab.class3 != '任选三' && this.innerTab.class3 != '任选四' && this.innerTab.class3 != '任选五')
          this.curInnerTab = this.innerTabs[0].value;
      }
    }
  },
  methods: {
    reset_selected() {
      each(item => {
        item.selected = false;
        item.isDantuoImg = false;
        item.value = '';
      }, this.$refs.c_model_input);
    },
    onTabChanged(tab) {
      //console.log('玩法切换', tab);
      this.$refs.c_model_input.onSetRadioRest && this.$refs.c_model_input.onSetRadioRest();
      const index = this.tabs.findIndex(item => item.sub_category_id == tab.value);
      if (index < 0) return alert('操作有误');
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          index: index
        }
      });
    },

    onShowResult() {
      this.showResult('d21', '开奖结果-' + this.head.title, {
        lottery_type: this.$route.query.lottery_type || 1,
        category_id: this.head.category
      });
    },
    onShowRule() {
      this.showResult('d13', '游戏规则-' + this.head.title, {
        lottery_type: this.$route.query.lottery_type || 1,
        category_id: this.head.category
      });
    },
    // 快速下单
    handleQuickCreate(data) {
      let orders = [];
      data.forEach(item => {
        this.odds.forEach(val => {    
          if(item.class3==val.class3){
            let info = {
              ...val,
              value: item.money,
              rate: val.odds,
              selected:false
            };
            orders.push(info);
          }
        });    
      });
      this.orders = orders;
      this.$refs.order.show();
      //this.order_sub(data, {fast_bet: 1});
    },
    handle_again() {
      if (!this.time) return this.$Message.error('封盘中，暂不支持选号');
      const {sub_category_id} = this.current;
      const category_id = this.head.category;
      const lottery_type = this.head.lottery_type;

      const key = createHistoryKey({
        sub_category_id,
        category_id,
        lottery_type
      });
      // 自动选择上一期号
      if (this.order_history[key] && this.order_history[key].length > 0) {
        const history = this.order_history[key];

        const items = history[history.length - 1];

        if (items.list.length < 1) return;

        each(item => {
          if (item.item && item.item.odds_tpl_id) {
            const odds_tpl_id = item.item.odds_tpl_id;
            const c = items.list.find(item => item.odds_tpl_id == odds_tpl_id);
            // 如果是选中
            if (!!c) {
              if(c.value!=undefined && c.value!=''){
                item.value = c.value;
                this.chip = c.value;
                this.$store.state.inputnum = c.value;
              }else{
                if (!this.chip) item.value = c.money;
                else
                item.value = this.chip;
              }
              item.selected = true;
            }

          }
        }, this.$refs.c_model_input);
      }
    },

    // 确认提交订单
    certain_handle() {

      if (!this.time) return this.$Message.error('封盘中，请等待下一期投注');

      let orders = [];
      each(item => {
        if (item.selected && item.value) {
          let info = {
            ...item.item,
            value: item.value,
            _haomaduipeng: item.haomaduipeng,
          };
          orders.push(info);
        }
      }, this.$refs.c_model_input);
      // 连码数据
      this.origin_list = null;

      // 六合
      if (
        (this.current.sub_category_id === 6 && this.current.label === '连肖') ||
        (this.current.sub_category_id === 7 && this.current.label === '连尾') ||
        (this.current.sub_category_id === 8 && this.current.label === '连码') ||
        (this.current.sub_category_id === 9 && this.current.label === '自选不中') ||
        (this.current.sub_category_id === 11 && this.current.label === '合肖') ||
        (this.current.sub_category_id === 12 && this.current.label === '特平中') ||
        (this.current.sub_category_id === 13 && this.current.label === '中一')
      ) {
        if (!parseFloat(this.chip)) return this.$Message.error('请选择投注金额');
        const firstOrder = objectPath.get(orders, `0`);
        const firstOrderClass2 = objectPath.get(orders, `0.class2`);
        const firstOrderClass1 = objectPath.get(orders, `0.class1`);
        // 判断号码
        if (!firstOrderClass2) return this.$Message.error(`请选择号码`);
        let ordersLength = lhCurrentTabLength(firstOrderClass2);
        // 胆拖号码
        if (orders.length < ordersLength) return this.$Message.error(`请最少选择${ordersLength}个号码`);
        if (orders.length > 2 && (this.playTypeRadio == 3 || this.playTypeRadio == 4 || this.playTypeRadio == 5)) return this.$Message.error(`最多选择2个号码`);
        // 校验胆拖号码的长度
        if ((firstOrderClass1 === '连肖' || firstOrderClass1 === '连尾' || firstOrderClass1 === '连码') && this.playTypeRadio == 2) {
          const checkLength = ordersLength - 1;
          const daotoLength = Object.keys(this.playDantuoTotal).length;
          if (daotoLength < checkLength) return this.$Message.error(`请最少选择${checkLength}个胆`);
        }
        if ((firstOrderClass1 === '连肖' || firstOrderClass1 === '连尾') && orders.length > 6) {
          //return this.$Message.error(`最多选择6个号码`);
        }
        if ((firstOrderClass1 === '自选不中' || firstOrderClass1 === '中一' || firstOrderClass1 === '特平中') && orders.length > 20) {
          return this.$Message.error(`最多选择20个号码`);
        }
        // 连码最多10个号码
        if (
          ((firstOrderClass2 === '三全中' || firstOrderClass2 === '三中二' || firstOrderClass2 === '三中二X') && (this.playTypeRadio == 1 || this.playTypeRadio == 2) && orders.length > 10)
        ) {
          return this.$Message.error(`最多选择10个号码`);
        }

        this.origin_list = [...orders];
        orders = lhComputedLm(orders, firstOrder, this.playTypeRadio, this.playDantuoTotal);
      } else if (this.current.sub_category_id === 12 || this.current.label === '连码') {
        if (!parseFloat(this.chip)) return this.$Message.error('请选择投注金额');
        if (orders.length < 2) return this.$Message.error('请最少选择两个号码');
        this.origin_list = [...orders];
        orders = computedLm(orders, this.innerTab);
      }
      if (orders.length < 1) return this.$Message.error('未选中订单或订单金额有误');

      this.orders = orders;
      this.$refs.order.show();
    },

    // 订单提交
    async order_sub(list, params = {}) {
      const {period} = this.lottery.next_info;
      const {sub_category_id} = this.current;
      const category_id = this.head.category;
      const lottery_type = this.head.lottery_type;

      if (!period) return this.$Message.error('下一期暂停投注');

      /***
       * 公参
       */
      if (!lottery_type || !category_id || !period || !sub_category_id) return;

      // 订单提交中
      if (this.order_subing) return;
      this.order_subing = true;
      const newList = onDeepData(list);
      // 删除掉多余的参数，ID必须要转成number类型
      newList.forEach(item => {
        delete item.oddsArr;
        delete item.label;
        delete item.numberGroup;
        delete item._status;
        delete item.selected;
        delete item.rate;
        delete item.value;
        delete item._haomaduipeng;
        if (item.id) {
          item.id = Number(item.id)
        }
      })
      const msg = await this.createOrder({
        lottery_type,
        category_id,
        period,
        sub_category_id,
        list: newList,
        origin_list: this.origin_list,
        ...params
      });

      this.order_subing = false;

      if (msg) return this.$Message.error(msg);

      this.$refs.order.hide();
      this.$Message.success('投注成功');
      Vue.$emit("reset");
      this.reset_selected();
      // 请求清空item
      this.onSetLhItemTotal({});
      //Vue.$emit("reset")
    },


    // 倒计时结束
    async handle_end(ctx) {
      // 防止重复调用，添加防抖标志
      if (this._handleEndLoading) {
        return;
      }
      
      this._handleEndLoading = true;
      
      let self = this;
      const lottery_type = this.$route.query.lottery_type || 1;
      const {sub_category_id} = this.current;
      
      try {
        // 倒计时结束后，强制调用接口获取最新的 next_info，更新期号和倒计时
        await this.getNewLotteryRes({
          sub_category_id,
          lottery_type
        });
        
        // 延迟一下，确保数据已更新，避免立即再次触发
        // await new Promise(resolve => setTimeout(resolve, 1000));
        
        if(lottery_type!=19 && lottery_type!=15){
          // 非19和15类型，更新完数据后直接返回
          this._handleEndLoading = false;
          return;
        }
        
        // 对于19类型，检查期号是否连续
        if (this.lottery.next_info.period - this.lottery.latest_result.period != 1) {
          // 期号不连续，等待3秒后再次检查
          setTimeout(() => {
            self._handleEndLoading = false;
            self.handle_end(ctx);
          }, 3000);
        } else {
          // 期号连续，播放提示音并更新其他数据
          var sound = localStorage.getItem('sound') || 0;
          if (sound == 1) {
            var _audio = document.getElementById('audio1');
            _audio && _audio.play();
          } else if (sound == 2) {
            var _audio = document.getElementById('audio2');
            _audio && _audio.play();
          } else if (sound == 3) {
            var _audio = document.getElementById('audio3');
            _audio && _audio.play();
          }
          await this.updateUserInfo();
          await this.getLotteryLatest();
          await this.getLongQueue({
            lottery_type
          });
          await this.getStatistics({
            lottery_type
          });
          this._handleEndLoading = false;
        }
      } catch (error) {
        console.error('handle_end error:', error);
        this._handleEndLoading = false;
      }
    },
    // 封盘状态判断
    changeFp(time) {
      this.time = time > 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/home/methods.js